import React from 'react';
import './basketPriceLine.scss';

const BasketDishPriceLine = (props) => {
    const { price, portion } = props;

    return (

        <div styleName="bakset-price-line-root">
            {portion && (
                <>
                    <div styleName="bakset-price-line-portion">
                        {portion}
                    </div>
                    <div styleName="bakset-price-line-multiplier">
                        <div>
                            x
                        </div>
                    </div>
                </>
            )}
            <div styleName="bakset-price-line-amount">
                {price}
            </div>
            <div styleName="bakset-price-line-rub">
                ₽
            </div>
        </div>
    );
};

export default BasketDishPriceLine;
